import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'

const TeamEventOverview = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`Event Overview | ${team.name} | ${guild.name}`}>
      TeamEventOverview! {team.id}
    </Section>
  )
}

export default TeamEventOverview
